import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ShopLayout from '../../components/shop/ShopLayout';
import api from '../../services/api';
import './AuthForm.css';
import Seo from '../../components/seo/Seo';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const res = await api.forgotPassword(email);
      setMessage(res.message);
    } catch (err) {
      setError(err.message || 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ShopLayout breadcrumbs={[{ label: 'Forgot Password' }]}>
      <Seo title="Forgot Password" path="/forgot-password" />
      <div className="container auth-page">
        <div className="auth-card">
          <h1>Forgot Password</h1>
          <p className="auth-card__subtitle">Enter your email and we&apos;ll send reset instructions.</p>
          <form className="auth-form" onSubmit={handleSubmit}>
            {error && <div className="auth-form__error">{error}</div>}
            {message && <div className="auth-form__success">{message}</div>}
            <div className="auth-form__field">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button type="submit" className="auth-form__submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send Reset Link'}
            </button>
          </form>
          <div className="auth-card__footer">
            <p><Link to="/login">Back to sign in</Link></p>
          </div>
        </div>
      </div>
    </ShopLayout>
  );
}

export default ForgotPasswordPage;
